/* src/module/ui-accessibility/components/skip-link/skip-link.component.scss */
.skip-link {
  transform: translateY(calc(-100% - 20px));
  transition: transform 0.3s;
  z-index: 999999;
  position: absolute;
  left: 10px;
  top: 20px;
  padding: 10px;
  background: white;
  border-radius: 2px;
  color: rgb(0, 56, 76);
  font-family:
    Heebo,
    Helvetica Neue,
    Arial,
    sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 22.5px;
}
.skip-link:focus {
  transform: translateY(0%);
  outline: 2px solid rgb(0, 140, 188);
}
@media (prefers-reduced-motion) {
  .skip-link {
    transition: none;
  }
}
/*# sourceMappingURL=skip-link.component-G4FVRXFN.css.map */
